import React from 'react'

const Logo = () => {
  return (
    <div>
      <img src={'/various/logotitlenavy.webp'}/>
    </div>
  )
}

export default Logo